<template>
  <div>
    <input
      v-if="((isWorker() || isFreelancer()) && !(timesheetForm.Status === $getConst.timesheetsStatus.processed
      || timesheetForm.Status === $getConst.timesheetsStatus.submitted
      || timesheetForm.Status === $getConst.timesheetsStatus.approved )) || $route.name === 'edit-terms-and-conditions'
       || $route.name === 'edit-privacy-policy'"
      type="file"
      name="file"
      id="file"
      class="input-file"
      :multiple="multipleFile"
      @change="handleInput"
      :accept="onlyPdf ? 'application/pdf': 'image/*, application/pdf, .xlsx, .xls, application/msword, .docx, .eml'"
    />
    <label
      v-if="((isWorker() || isFreelancer()) && !(timesheetForm.Status === $getConst.timesheetsStatus.processed
        || timesheetForm.Status === $getConst.timesheetsStatus.submitted
        || timesheetForm.Status === $getConst.timesheetsStatus.approved )) || $route.name === 'edit-terms-and-conditions'
        || $route.name === 'edit-privacy-policy'"
      for="file"
    >
      <i :class="[$getConst.icons.upload, 'mr-2']"/>
      <span v-if="!count">{{$getConst.pages.form.choose_file}}</span>
      <span v-else>{{count}} {{$getConst.pages.form.files_selected}}</span>
    </label>
    <div v-bind:class="{ 'row': !multipleFile }">
      <div class="col-md-4" v-if="!multipleFile"></div>
      <div v-bind:class="{ 'col-md-6': !multipleFile }">
        <ul class="pl-4" v-if="attachments.length > 0 || filesNames.length > 0">
          <li v-for="(name, index) in filesNames">
            <div class="col-md-12" style="display: flex; padding: 0;">
              <div class="col-md-7" style="padding: 0;">{{name.name}}</div>
              <div class="col-md-5 text-right p-0">
                <b-button
                  :id="'delete-button-'+index"
                  v-if="(isWorker() || isFreelancer()) && !(timesheetForm.Status === $getConst.timesheetsStatus.processed
                    || timesheetForm.Status === $getConst.timesheetsStatus.submitted
                    || timesheetForm.Status === $getConst.timesheetsStatus.approved )"
                  class="ml-auto border-0 py-0 font-size-sm"
                  variant="dark-outline"
                  @click="deleteFromFiles(index)">
                  <i  :class="$getConst.icons.delete"></i>
                </b-button>
                <b-button :id="'preview-button-'+index"
                          class="ml-auto border-0 py-0 font-size-sm"
                          variant="dark-outline"
                          @click="preview(index)">
                  <i :class="$getConst.icons.eye"></i>
                </b-button>
                <b-button :id="'download-button-'+index"
                          v-if="multipleFile"
                          class="ml-auto border-0 py-0 font-size-sm"
                          variant="dark-outline"
                          @click="download(name.name, index)">
                  <i :class="[$getConst.icons.download, 'mr-2']"></i>
                </b-button>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="col-md-2" v-if="!multipleFile"></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "AppFormFileInput",
    props: {
      onlyPdf: Boolean,
      multipleFile: Boolean,
      timesheetForm: Object,
      timesheetAttachements: Array,
      'value' : Array,
        timesheetsConfig: Object
    },
    data() {
      return {
        files: [],
        count: 0,
        filesNames: [],
        attachments: [],
        uploadFieldName: 'photos',
        MO: 1024 * 1024,
        MAX_TOTAL_SIZE: 12 * 1024 * 1024 , //Max total size accepted is 12 MB
        MAX_FILE_SIZE : 4 * 1024 * 1024, //Max file size accepted is 4 MB
        TOTAL_FILES_SIZE : 0,
        SUPPORTED_TYPES : ['png', 'jpe', 'jpeg', 'jpg', 'gif', 'bmp', 'ico', 'tiff', 'tif', 'svg', 'svgz', 'pdf', 'xls', 'xlsx', 'doc', 'docx', 'eml', 'txt']

      }
    },
    created(){
      this.getOldAttachements();
      if (this.timesheetsConfig) {
          this.MAX_TOTAL_SIZE = this.timesheetsConfig.max_total_files_size * this.MO;
          this.MAX_FILE_SIZE = this.timesheetsConfig.max_file_size * this.MO;
      }
    },
    methods: {
      getOldAttachements(){
        if(!this.multipleFile && this.timesheetAttachements.length>0){
          this.filesNames = [];
        }
        var mime = require('mime-types');

        if(this.timesheetAttachements && this.timesheetAttachements.length>0){
          for(let i =0; i<this.timesheetAttachements.length; i++) {
            this.TOTAL_FILES_SIZE += this.timesheetAttachements[i].FileSize;
            this.filesNames.push({
              'name': this.timesheetAttachements[i].FileName,
              'type': mime.lookup(this.timesheetAttachements[i].FileName.split('.').pop())
            });
          }

          this.attachments = this.timesheetAttachements;
          this.count = this.timesheetAttachements.length;
        }
      },
      handleInput(event) {
        this.files = [];
        let newFiles;
        this.attachments.forEach(attachement => {
          this.TOTAL_FILES_SIZE += attachement.FileSize
        });
        newFiles = Array.from(event.target.files);
        for(let j = 0; j< newFiles.length; j++){
            if(newFiles[j].size+this.TOTAL_FILES_SIZE > this.MAX_TOTAL_SIZE) {
            this.$snotify.error(`${this.$t(this.$getConst.pages.alerts.max_total_size_exceeded)}`);
            break;
          }
           if(this.isFileTypeNotSupported(newFiles[j].name) === true) {
                this.$snotify.error(`${this.$t(this.$getConst.pages.alerts.file_not_supported)}: ${newFiles[j].name}`);
            } else if(newFiles[j].size < this.MAX_FILE_SIZE && newFiles[j].size > 0){
            this.files.push(newFiles[j]);
            this.TOTAL_FILES_SIZE += newFiles[j].size;
          } else if (newFiles[j].size > this.MAX_FILE_SIZE) {
            this.$snotify.error(`${this.$t(this.$getConst.pages.alerts.too_large_file)}: ${newFiles[j].name}`);
          }else {
            this.$snotify.error(
              `${this.$t(this.$getConst.pages.alerts.empty_file)}: ${newFiles[j].name}`,
              newFiles[j].name
            );
          }
        }
        for (let i = 0; i < this.files.length; i++) {
          let reader = new FileReader();
          let existFile = false;
          reader.readAsDataURL(this.files[i]);
          reader.onload = () => {
            let b64 = reader.result.replace(/^data:.+;base64,/, '');
            for(let j =0; j<this.attachments.length; j++){
              if(this.attachments[j].FileBase64 === b64 && this.attachments[j].FileName === this.files[i].name){
                existFile = true;
                break;
              }else{
                existFile = false;
              }
            }
            if(!existFile){
              if(this.multipleFile){
                this.filesNames.push({'name':this.files[i].name, 'type': this.files[i].type});
                this.attachments.push({'FileName': this.files[i].name, 'FileBase64': b64, 'FileSize': this.files[i].size,
                  'FileType': this.files[i].type});
                this.count += 1;
              }else{
                this.filesNames = [{'name':this.files[i].name, 'type': this.files[i].type}];
                this.attachments = [{'FileName': this.files[i].name, 'FileBase64': b64, 'FileSize': this.files[i].size,
                  'FileType': this.files[i].type}];
                this.count = 1;
              }
              this.$emit('input', this.attachments);
            }
          };
        }
        this.$emit('input', this.attachments);
        event.target.value = null;
      },
      deleteFromFiles(index){
        this.filesNames.splice(index, 1);
        this.attachments.splice(index, 1);
        this.count -= 1;
        this.$emit('input', this.attachments);
      },
      isFileTypeNotSupported(fileName) {
        return !this.SUPPORTED_TYPES.includes(fileName.split('.').pop());
      },
      preview(index){
        let win = window.open();
        if (this.filesNames[index].type.includes("image")) {
          win.document.write(
            '<title>'+`${this.filesNames[index].name}`+'</title><img src="' +
            `data:${this.filesNames[index].type};base64,${this.attachments[index].FileBase64}` +
            '" frameborder="0" ' +
            'style="border:0; top:0px; left:0px; bottom:0px; right:0px; height:100%;">' +
            '</img>');
        } else {
          win.document.write(
            '<title>'+`${this.filesNames[index].name}`+'</title><iframe src="' +
            `data:${this.filesNames[index].type};base64,${this.attachments[index].FileBase64}` +
            '" frameborder="0" ' +
            'style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen>' +
            '</iframe>');
        }
        win.document.close();
      },
      download(name, index){
        const linkSource = `data:${this.filesNames[index].type};base64,${this.attachments[index].FileBase64}`;
        const downloadLink = document.createElement("a");
        downloadLink.href = linkSource;
        downloadLink.download = name;
        downloadLink.click();
      }
    }
  }
</script>

<style scoped>
  .btn {
    padding-top: 0rem;
    padding-right: 0.4rem;
    padding-bottom: 0rem;
    padding-left: 0;
  }
  .card-body  .mx-auto{
    display: contents;
  }

</style>
